module.exports = __webpack_public_path__ + "public/img/qrcode-wechat.52d5d6f7.png";